
import React, { Component, Fragment } from 'react';
import { Input, InputGroup } from 'reactstrap';
import { ArcaValidation } from '../../../code/ArcaValidation';
import { TickCross } from '../ReactIcons/TickCross';
import { InputLookup } from './InputLookup';
import { PhotoSelect } from './PhotoSelect';
import { PrePendText } from './PrePendText';

export class InputField extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: this.props.value ?? '',
            status: '',
            mandatory: this.props.mandatory,
            fieldValid: null,
            fieldType: this.props.regularExpression === 'password'
                ? 'password'
                : this.props.fieldType ?? 'text',
            label: this.props.label ?? this.props.fieldname,
            fieldClass: this.props.fieldClass ?? 'inputField',
            prependWidth: '100%',
            isLoading: true,
            showHelp: false
        };
    }

    render() {
        let warning = ''
        let { fieldType, prependWidth, showHelp, label, fieldClass } = this.state;
        let { mandatory, description } = this.props;

        if (this.props.regularExpression !== null
            && this.props.regularExpression !== '' ) {
            warning = (this.state.status !== '' ? this.state.status : '');
        }

        return (
            <Fragment>
                <div className={fieldClass}>
                    {fieldType === 'select'
                        ? <InputLookup
                            label={this.props.label}
                            fieldname={this.props.fieldname}
                            regularExpression={this.props.regularExpression}
                            warnText={this.props.warnText}
                            mandatory={this.props.mandatory}
                            value={this.props.value}
                            onUpdate={this.props.onUpdate}
                            fieldValid={this.props.fieldValid}
                            listName={this.props.regularExpression}
                            prependWidth={prependWidth}
                            description={this.props.description}
                            inline={this.props.inline}
                        />
                        : fieldType === 'photo'
                            ? <PhotoSelect
                                label={this.props.label}
                                fieldname={this.props.fieldname}
                                regularExpression={this.props.regularExpression}
                                warnText={this.props.warnText}
                                mandatory={this.props.mandatory}
                                value={this.props.value}
                                onUpdate={this.props.onUpdate}
                                fieldValid={this.props.fieldValid}
                                listName={this.props.regularExpression}
                                prependWidth={prependWidth}
                                inline={this.props.inline}
                            />
                            : <Fragment>
                                <InputGroup>

                                    <PrePendText
                                        prependWidth={prependWidth}
                                        mandatory={mandatory}
                                        label={label}
                                        description={description}
                                        showHelp={showHelp}
                                        onClick={(() => this.setState({ showHelp: !showHelp }))}
                                    />

                                    {/*<InputGroupAddon addonType='append' >*/}
                                        <TickCross hidden={!this.props.mandatory} ticked={this.state.fieldValid} height='25px'></TickCross>
                                    {/*</InputGroupAddon>*/}
                                </InputGroup>

                                <Input
                                    type={fieldType}
                                    disabled={(this.props.disabled) ? "disabled" : ""} 
                                    rows={fieldType === 'textarea' ? '4' : null}
                                    onChange={this.handleUserInput.bind(this)}
                                    value={this.state.value} />


                                <span style={{ 'color': 'red' }}>{warning}</span>


                                {description && showHelp ?
                                    <div className='inputFieldDescription'>
                                        {description}
                                    </div>
                                    : null}

                            </Fragment>}
                </div>
            </Fragment>
        );
    }

    handleUserInput = (e) => {
        const value = e.target.value;

        var valid = ArcaValidation.ValidateValue(value, this.state.mandatory, this.props.regularExpression);
        this.props.onUpdate(
            (this.props.fieldType === 'integer' ? parseInt(value) : value),
            valid,
            this.props.fieldname);

        this.setState({
            value: value,
            fieldValid: valid,
            status: valid || value === ''
                ? ''
                : this.props.warnText
        });
    }
}
